// ============================================================
// GEOCODING UTILITY - Convert addresses to coordinates
// File: src/utils/geocoding.js
// Use this to geocode addresses anywhere in the app
// ============================================================

// Note: For client-side React apps, the API key must be in an environment variable
// prefixed with REACT_APP_ to be accessible via process.env
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_GEOCODING_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY

/**
 * Geocode an address to get latitude and longitude
 * @param {string} address - Full address string
 * @param {string} city - City
 * @param {string} state - State
 * @param {string} zip - Zip code
 * @returns {Promise<{latitude: number, longitude: number, success: boolean, error?: string}>}
 */
export async function geocodeAddress(address, city, state, zip) {
  try {
    // Build full address
    const fullAddress = `${address}, ${city}, ${state} ${zip}`
    const encodedAddress = encodeURIComponent(fullAddress)
    
    // Call Google Geocoding API
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${GOOGLE_MAPS_API_KEY}`
    
    const response = await fetch(url)
    const data = await response.json()
    
    if (data.status === 'OK' && data.results.length > 0) {
      const location = data.results[0].geometry.location
      return {
        latitude: location.lat,
        longitude: location.lng,
        success: true
      }
    } else if (data.status === 'ZERO_RESULTS') {
      return {
        success: false,
        error: 'Address not found. Please verify the address is correct.'
      }
    } else if (data.status === 'OVER_QUERY_LIMIT') {
      return {
        success: false,
        error: 'Geocoding limit reached. Please try again in a moment.'
      }
    } else {
      return {
        success: false,
        error: `Geocoding failed: ${data.status}`
      }
    }
  } catch (error) {
    console.error('Geocoding error:', error)
    return {
      success: false,
      error: 'Network error. Please check your connection and try again.'
    }
  }
}
